import { SectionHeading } from "./SectionHeading";
import { PERSONAS } from "@/data/content";

export const WhoItsFor = () => (
  <section id="who-its-for" className="cd-section border-t border-[#bdbdb4] bg-[#efefe6]" data-testid="who-its-for-section">
    <div className="mx-auto max-w-[1360px] px-5 sm:px-8">
      <SectionHeading id="who-its-for" title="Who we serve" />
      <div className="cd-reveal mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
        {PERSONAS.map((p, i) => (
          <article key={p.title} className="cd-card flex flex-col bg-[#f5f5ee] p-7 sm:p-8" data-testid={`persona-card-${i + 1}`}>
            <span className="self-start bg-[#fff0e5] px-2 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-[#d65300]">{p.tag}</span>
            <h3 className="mt-8 font-display text-2xl font-semibold tracking-[-0.02em] text-[#292929]" data-testid={`persona-title-${i + 1}`}>{p.title}</h3>
            <p className="mt-4 text-[15px] leading-relaxed text-[#55554f]">{p.body}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
